import ComponentManager from '@/Management/ComponentManager';
import PasswordBox from '@/Controls/PasswordBox';
import Label from '@/Controls/Label';
import TwoFactorPopup from '@/Components/TwoFaktorAuth/PopupWindow/TwoFactorPopup';
import TwoFactorAuthSelfServiceViewViewModel from '@/Components/TwoFaktorAuth/SelfService/TwoFactorSelfServiceViewViewModel';
import layout from './TwoFactorSelfService.html?raw';
export default class TwoFactorSelfServiceViewWindow extends TwoFactorPopup {

    public constructor(public viewModel: TwoFactorAuthSelfServiceViewViewModel, element?: JQuery) {
        super(viewModel, element);
    }

    protected onAfterRender(): void {
        let $block = this.$element.find('.qr-buttons-block');
        let $passwordBlock = $('<div class="password-block">');
        $block.prepend($passwordBlock);

        let label = new Label(this.viewModel.passwordLabel);
        $passwordBlock.append(label.getTuple().control);
        let box = new PasswordBox(this.viewModel.passwordBox);
        $passwordBlock.append(box.getTuple().control);

        this.applyBindings($passwordBlock, {
            visible: this.viewModel.showPassword
        });

        this.viewModel.isOpen(true);
    }
}

ComponentManager.setControl('TwoFactorSelfServiceViewWindow', TwoFactorSelfServiceViewWindow, 'RADPresentation.HTMLClient.DefaultViewExtensions');